import { render, staticRenderFns } from "./ProjectCollectionFiltersNew.vue?vue&type=template&id=c6c850b8&scoped=true"
import script from "./ProjectCollectionFiltersNew.vue?vue&type=script&lang=ts"
export * from "./ProjectCollectionFiltersNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCollectionFiltersNew.vue?vue&type=style&index=0&id=c6c850b8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c850b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c850b8')) {
      api.createRecord('c6c850b8', component.options)
    } else {
      api.reload('c6c850b8', component.options)
    }
    module.hot.accept("./ProjectCollectionFiltersNew.vue?vue&type=template&id=c6c850b8&scoped=true", function () {
      api.rerender('c6c850b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ProjectCollectionFiltersNew.vue"
export default component.exports